import React from "react"
import { Helmet } from "react-helmet"

import site from "data/site.json"
import { organization, website } from "./structured-data"

const Seo = ({ title, description, path, image, imageAlt, entities = [] }) => {
  const url = new URL(path, site.url).href
  const imageUrl = new URL(image || site.logo, site.url).href
  const structuredData = {
    "@context": "https://schema.org",
    "@graph": [
      organization,
      website,
      ...entities,
      {
        "@type": "WebPage",
        "@id": `${url}#webpage`,
        url,
        name: title,
        description,
        isPartOf: { "@id": website["@id"] },
        publisher: { "@id": organization["@id"] },
        inLanguage: "en-GB",
        ...(entities.length && {
          mainEntity: { "@id": entities[0]["@id"] },
        }),
      },
    ],
  }

  return (
    <Helmet htmlAttributes={{ lang: "en-GB" }}>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={site.name} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:image:alt" content={imageAlt || site.name} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
      <meta name="twitter:image:alt" content={imageAlt || site.name} />
      <script type="application/ld+json">
        {JSON.stringify(structuredData).replace(/</g, "\\u003c")}
      </script>
    </Helmet>
  )
}

export default Seo
